import ReactDOM from "react-dom";
import React from "react";


import {Row, Col, Button} from "react-bootstrap";


import {AiOutlineClose} from "react-icons/all";


interface ModalMessageComponentProps {
    type?: "DEFAULT" | "SUCCESS" | "ERROR";
    message: string;
    openStatus: boolean;
    closeHandler(): void;
    acceptHandler?(): void;
    declineHandler?(): void;
}


export const ModalMessageComponent: React.FC<ModalMessageComponentProps> = ({
    type = "DEFAULT",
    message,
    openStatus = false, closeHandler,
    acceptHandler, declineHandler
}) : JSX.Element | null => {


    if (!message || !openStatus) return null;


    let cssClasses = "modal-message modal-message-component";


    switch (type) {
        case "SUCCESS":
            cssClasses += " success-message";
            break;
        case "ERROR":
            cssClasses += " error-message";
    }


    return (ReactDOM.createPortal(
        <Col xs={12} className={cssClasses}>
            <Row className={"modal-message-content"}>

                <Col xs={12} className={"modal-message-text"}>

                    <span className={"close-message-button"} onClick={closeHandler}>
                        <AiOutlineClose />
                    </span>

                    <span className={"message-text"}>{message}</span>

                    {(!!acceptHandler || !!declineHandler) &&
	                <Row className={"message-buttons"}>
                        {!!acceptHandler &&
		                <Col xs={6} className={"text-center message-accept-button"}>
			                <Button variant={"success"} onClick={acceptHandler}>{`Potwierdź`}</Button>
		                </Col>
                        }

                        {!!declineHandler &&
		                <Col xs={6} className={"text-center message-decline-button"}>
			                <Button variant={"danger"} onClick={closeHandler} >{`Odrzuć`}</Button>
		                </Col>
                        }
	                </Row>
                    }

                </Col>

            </Row>
        </Col>
        ,document.body
    ));

};


export default ModalMessageComponent;
